<template>
    <div class="popup">
        <div class="popup__inner shadow-2xl high-contrast:bg-black high-contrast:border-yellow-300 high-contrast:border">
            <div class="popup__header">
                <div class="popup__title">
                    <template v-if="hasTitleSlotDefined">
                        <slot name="title" />
                    </template>
                    <span v-else class="h3">{{ title }}</span>
                </div>
                <span v-if="allowClosing" class="popup__close" @click="close()" />
            </div>
            <div class="popup__content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        allowClosing: {
            type: Boolean,
            required: false,
            default: true
        },
        title: {
            type: String,
            required: false,
            default: ""
        }
    },
    computed: {
        hasTitleSlotDefined() {
            return !! this.$slots.title;
        }
    },
    mounted() {
        const el = document.body;
        el.classList.add("modal-open");
    },
    destroyed() {
        const el = document.body;
        el.classList.remove("modal-open");
    },
    methods: {
        close() {
            const el = document.body;
            el.classList.remove("modal-open");

            this.$emit('close');
        }
    }
};
</script>